module.exports = __webpack_public_path__ + "assets/Search.e2080d91.svg";